module.exports = __webpack_public_path__ + "static/media/icon-stackoverflow.6445fcf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-stackoverflow.svg
// module id = 513
// module chunks = 0